export default __webpack_public_path__ + "static/media/arrow-left.5b8f1a3c.svg";